import { computed, ref } from 'vue';
import { useTask } from '@/ui/concerns';
import { list } from '@/services/api/resources/schedule';
import { sequence } from '@/ui/helpers';
import { ScheduleQuery } from '@/services/api/resources/schedule/query';

export const useScheduleCheck = () => {
  const checkLoading = ref<boolean>(true);
  const checkResult = ref<boolean|undefined>();

  const query = (): ScheduleQuery => ({
    search: '',
    sort: '',
    entities: [],
    checklists: [],
    assignees: [],
    dir: '',
    page: 1,
    perPage: 1,
  });

  const performCheck = useTask(
    () => sequence(
      list(query()),
    ),
    ([
      listResponse,
    ]) => {
      checkResult.value = listResponse.data.length > 0;
      checkLoading.value = false;
    },
  );

  const taskReportCheck = computed(() => performCheck);

  return {
    checkLoading,
    checkResult,
    taskReportCheck,
    performCheck,
  };
};
